
import { Question } from './types';
import { defaultFolders } from './folders';
import { defaultUsers } from './users';

export { defaultFolders, defaultUsers };

// Empty default questions to provide a clean system with just the folder structure.
export const defaultQuestions: Question[] = [];
